// ─── DATE HELPERS ─────────────────────────────────────────────────────────────
// Small, dependency-free date utilities used app-wide. All formatting uses LOCAL
// date parts (getFullYear/getMonth/getDate) so PH-timezone dates never drift.

export const now = () => new Date();
export const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
export const todayStr = () => fmt(now());

// Safely parse a createdAt string — handles both full ISO ("2025-05-06T16:00:00.000Z") and plain date ("2025-05-07").
// Full ISO strings are UTC, so we use local date parts instead of .slice(0,10) to avoid timezone off-by-one.
export const localDateStr = (str) => {
  if (!str) return "";
  if (str.length === 10) return str; // already "YYYY-MM-DD"
  const d = new Date(str);
  return fmt(d); // fmt uses local getFullYear/getMonth/getDate — correct for PH timezone
};

export const daysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();

// ─── DAY-START-HOUR GRID TRANSFORM ──────────────────────────────────────────
// The Day/Week timeline grids default to row 0 = midnight, but that's
// customizable (Settings → Day Starts At) so the first row can instead be
// whatever hour someone actually starts their day. The grids themselves stay
// "minutes since midnight" internally for anything that's a pure duration or
// already grid-relative (drag-to-create state, resize deltas, drag-preview
// position) — only two kinds of values ever need translating:
//   - an absolute wall-clock time (parsed from a saved item's `time`, or from
//     `now()`) being turned into a vertical grid position → toGridMinutes
//   - a grid-relative position (from a draw/drag gesture) being turned into
//     a real time string to save or display → toAbsoluteMinutes
// Both wrap at 1440 (24h) so the transform is its own inverse.
export const toGridMinutes = (absoluteMinutes, dayStartHour = 0) =>
  ((absoluteMinutes - dayStartHour * 60) % 1440 + 1440) % 1440;
export const toAbsoluteMinutes = (gridMinutes, dayStartHour = 0) =>
  (gridMinutes + dayStartHour * 60) % 1440;
